/**
 * BELL LITE/MINI 설정 화면은 Web Serial(USB) 및 Web Bluetooth에 의존합니다.
 *
 * iOS/iPadOS에서는 **모든 브라우저**(Safari, Chrome, Edge, Firefox 등)가 WebKit만 사용하므로
 * 데스크톱 크롬과 달리 Web Serial·Web Bluetooth를 쓸 수 없습니다. → 설정자 진입 비활성.
 *
 * UA에 `CriOS`(iOS Chrome), `FxiOS`, `EdgiOS`가 있어도 동일하게 제외합니다.
 */
export function supportsLocalUsbBleConfigurator(): boolean {
  if (typeof navigator === 'undefined') {
    return true;
  }
  const ua = navigator.userAgent;
  const isIOSOrIPadOS =
    /iPad|iPhone|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
    /\b(CriOS|FxiOS|EdgiOS)\//.test(ua);
  return !isIOSOrIPadOS;
}
